<template>
    <div id="AccountLanding" :class="{'centered-view': !embedded}">
        <div :class="{'limit-width': !embedded}">
            <h1><b>Inicia sesión</b>  <br> o <br> <b>crea tu cuenta</b></h1>
            <div class="block text-center">
                Para contiuar, debes crear tu cuenta Blackfon® o iniciar sesión. <br>
                <b>Es fácil y rápido.</b>
            </div>
            <b-row class="mt-3 fix-gap" align-h="center">
                <b-col lg="4"  sm="12">
                    <b-button block variant="primary" @click="$router.push({name: 'AccountSignup'})">
                        Crear cuenta
                    </b-button>
                </b-col>
                <b-col lg="4" sm="12">
                    <b-button block variant="secondary" @click="$router.push({name: 'AccountLogin'})">
                        Iniciar sesión
                    </b-button>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import {requireConfigMsisdn } from '@/dexie/msisdn'
export default {
    name: 'AccountLanding',
    props: {
        embedded: {
            type: Boolean,
            default: false
        }
    },
    async beforeMount(){
        requireConfigMsisdn()
    }
}
</script>


<style lang="less">
    #AccountLanding {
        .fix-gap {
            gap: 1em;
        }
    }
</style>